import { Box, Image, Text } from "@chakra-ui/react";

type ProfileAvatarProps = {
  platform: "instagram" | "facebook";
  name: string;
  pictureUrl?: string;
  size: string;
};

function AvatarFace({
  name,
  pictureUrl,
}: {
  name: string;
  pictureUrl?: string;
}) {
  return (
    <Box
      w="full"
      h="full"
      borderRadius="full"
      bg="gray.200"
      display="flex"
      alignItems="center"
      justifyContent="center"
      overflow="hidden"
    >
      {pictureUrl ? (
        <Image
          src={pictureUrl}
          alt={`${name} profile`}
          w="full"
          h="full"
          objectFit="cover"
        />
      ) : (
        <Text fontSize="xs" fontWeight="bold" color="gray.600">
          {name.charAt(0).toUpperCase()}
        </Text>
      )}
    </Box>
  );
}

export function ProfileAvatar({
  platform,
  name,
  pictureUrl,
  size,
}: ProfileAvatarProps) {
  if (platform !== "instagram") {
    return (
      <Box w={size} h={size} borderRadius="full" overflow="hidden">
        <AvatarFace name={name} pictureUrl={pictureUrl} />
      </Box>
    );
  }

  return (
    <Box
      w={size}
      h={size}
      borderRadius="full"
      bg="linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)"
      p="2px"
    >
      <Box w="full" h="full" borderRadius="full" bg="white" p="2px">
        <AvatarFace name={name} pictureUrl={pictureUrl} />
      </Box>
    </Box>
  );
}
